export default __webpack_public_path__ + "static/media/Landing-gmm5.bbbb9f16.png";